import { render, staticRenderFns } from "./UserSecurityChecker.vue?vue&type=template&id=97b1d748&scoped=true"
import script from "./UserSecurityChecker.vue?vue&type=script&lang=js"
export * from "./UserSecurityChecker.vue?vue&type=script&lang=js"
import style0 from "./UserSecurityChecker.vue?vue&type=style&index=0&id=97b1d748&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b1d748",
  null
  
)

export default component.exports